<div class="flex flex-row justify-between">
  <p-breadcrumb
    [model]="[]"
    [home]="home"
  />
</div>
<p-table
  [columns]="cols"
  [value]="service.auditLogs"
  [scrollable]="true"
  [virtualScroll]="true"
  [virtualScrollItemSize]="46"
  showGridlines
  scrollHeight="calc(100svh - 50px - 1.5rem)"
  [tableStyle]="{ 'min-width': '50rem' }"
  [globalFilterFields]="['app', 'created', 'aufgabeId', 'fallaufgabeId', 'routeInfo', 'teilaufgabeId', 'userId', 'userType', 'versionsUnique', 'duration', 'duration', 'level', 'msg', 'requestId']"
>
  <ng-template
    #header
    let-columns
  >
    <tr>
      @for (col of columns; track $index) {
      <th style="min-width: 200px; ">{{col.header}}</th>
      }
    </tr>
    <tr>
      <th>
        <p-columnFilter
          field="app"
          matchMode="equals"
          [showMenu]="false"
        >
          <ng-template
            #filter
            let-value
            let-filter="filterCallback"
          >
            <p-select
              [ngModel]="value"
              (ngModelChange)="filter($event)"
              [options]="this.apps"
              placeholder="Wähle App"
              [showClear]="true"
              class="w-full"
            >
              <ng-template
                let-option
                #item
              >
                <p-tag [value]="option.value"></p-tag>
              </ng-template>
            </p-select>
          </ng-template>

        </p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="date"
          field="created"
          [showMenu]="false"
          placeholder="Wähle Datum"
          dateFormat="dd.mm.yy"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="msg"
          placeholder="Suche Nachricht"
          ariaLabel="Filter msg"
          [showMenu]="false"
          filterOn="input"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="statusId"
          placeholder="Durchführungs ID"
          ariaLabel="Filter aufgabeId"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="aufgabeId"
          placeholder="Suche Aufgabe ID"
          ariaLabel="Filter aufgabeId"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="fallaufgabeId"
          placeholder="Suche Fallaufgabe ID"
          ariaLabel="Filter fallaufgabeId"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="routeInfo"
          placeholder="Suche Route Info"
          ariaLabel="Filter routeInfo"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="teilaufgabeId"
          placeholder="Suche Teilaufgabe ID"
          ariaLabel="Filter teilaufgabeId"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="userId"
          placeholder="Suche User ID"
          ariaLabel="Filter userId"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="userType"
          placeholder="Suche User Type"
          ariaLabel="Filter userType"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="versionsUnique"
          placeholder="Suche Versions Unique"
          ariaLabel="Filter versionsUnique"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="duration"
          placeholder="Suche Dauer"
          ariaLabel="Filter duration"
          filterOn="input"
          [showMenu]="false"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="level"
          placeholder="Suche Label"
          ariaLabel="Filter level"
          [showMenu]="false"
          filterOn="input"
        ></p-columnFilter>
      </th>
      <th>
        <p-columnFilter
          type="text"
          field="requestId"
          placeholder="Suche Request ID"
          ariaLabel="Filter requestId"
          [showMenu]="false"
          filterOn="input"
        ></p-columnFilter>
      </th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-columns
    let-auditlog
  >
    <tr style="height:46px">
      <td>{{ auditlog.app }}</td>
      <td>{{ auditlog.created | date:'dd.MM.yyyy | HH:mm' }}</td>
      <td>{{ auditlog.msg }}</td>
      <td>{{ auditlog.data.statusId }}</td>
      <td>{{ auditlog.data.aufgabeId }}</td>
      <td>{{ auditlog.data.fallaufgabeId }}</td>
      <td style="min-width: 400px; ">{{ auditlog.data.routeInfo }}</td>
      <td>{{ auditlog.data.teilaufgabeId }}</td>
      <td>{{ auditlog.data.userId }}</td>
      <td>{{ auditlog.data.userType }}</td>
      <td>{{ auditlog.data.versionsUnique }}</td>
      <td>{{ auditlog.duration }}</td>
      <td>{{ auditlog.level }}</td>
      <td>{{ auditlog.requestId }}</td>
    </tr>
  </ng-template>
</p-table>